class SafeStateChanger {
  changeValue(state, property, value) {
    return Object.assign({}, state, {
      [property]: value
    });
  }
  merge(stateA, stateB) {
    return Object.assign({}, stateA, stateB);
  }
}
const safeStateChanger = new SafeStateChanger();
export default safeStateChanger;